module.exports = __webpack_public_path__ + "img/feature3-1.80c57d8d.png";